import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { MultiSelectItem } from '@/main/store/@types/dropdown.d';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const filter = {
	State: null as string | null,
	City: null as string | null,
	PartNumber: null as string | null,
	DealerList: null as string[] | null,
};

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		DealerList: [],
	},
	filter,
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
